import { contractServiceClient } from '@lib/documentServiceClient';
import { createTemplateService } from '@workpay/ds-shared/services/templateService';

export const dsTemplateService = createTemplateService(contractServiceClient);
